import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import React, { useCallback } from 'react'
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native'
import { MortalityType } from '../../../../context/SeaWater/types'
import { white, grayBorders, toqueColor, corporateColor } from '../../../../theme/colors'

interface ItemProps {
  item: MortalityType
  isCheck: boolean
  onPress: (values: { id: number; name: string }) => void
}

const MortalityItemComponent = ({ item, isCheck, onPress }: ItemProps) => {
  const handlePress = useCallback(() => {
    onPress({ id: item.mortalityTypeId, name: item.name })
  }, [item.mortalityTypeId, item.name, onPress])

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={handlePress} style={styles.checkContainer}>
        <View style={[styles.check, isCheck && styles.checkActive]}>
          <FontAwesomeIcon icon={faCheck} color={white} size={20} />
        </View>
        <Text style={[styles.label, isCheck && styles.labelActive]}>{item.name}</Text>
      </TouchableOpacity>
    </View>
  )
}

export const MortalityItem = React.memo(MortalityItemComponent, (prev, next) => {
  return prev.isCheck === next.isCheck && prev.item.mortalityTypeId === next.item.mortalityTypeId
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
    margin: 10,
    marginHorizontal: 0,
  },

  checkContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  check: {
    width: 25,
    height: 25,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: grayBorders,
    backgroundColor: white,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },

  checkActive: {
    borderColor: toqueColor,
    backgroundColor: toqueColor,
  },

  label: {
    fontSize: 16,
    color: corporateColor,
    fontWeight: 'bold',
  },
  labelActive: {
    color: toqueColor,
  },
})
